import { type FC, useState } from "react";
import {
  Box,
  FormControlLabel,
  FormGroup,
  Popover,
  Switch,
  Typography,
} from "@mui/material";
import { useTranslation } from "@/shared/hooks";
import {
  getChatSoundSettings,
  setChatSoundSettings,
  type ChatSoundSettingsValue,
} from "./useChatSoundNotifications";

interface ChatSoundSettingsProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const ChatSoundSettings: FC<ChatSoundSettingsProps> = ({
  anchorEl,
  onClose,
}) => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState<ChatSoundSettingsValue>(
    getChatSoundSettings(),
  );

  const update = (key: keyof ChatSoundSettingsValue, value: boolean) => {
    const next = { ...settings, [key]: value };
    setSettings(next);
    setChatSoundSettings(next);
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Box sx={{ p: 2, minWidth: 220 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {t("stream.chat.sound.title")}
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={settings.reply}
                onChange={(event) => update("reply", event.target.checked)}
              />
            }
            label={t("stream.chat.sound.reply")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={settings.mention}
                onChange={(event) => update("mention", event.target.checked)}
              />
            }
            label={t("stream.chat.sound.mention")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={settings.join}
                onChange={(event) => update("join", event.target.checked)}
              />
            }
            label={t("stream.chat.sound.join")}
          />
        </FormGroup>
      </Box>
    </Popover>
  );
};
